import types from '../actions/types';
import {
    multipleResultReducer,
    multipleResultInitialState
} from './common/multiple-results';

const initial_state = {
    results: multipleResultInitialState
}

export default function(state = initial_state, action) {
    switch (action.type) {

        default: return {
            ...state,
            results: multipleResultReducer(state.results, types.LOAD_RESULTS, action)
        };
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/results.js